/**
 * Campaigns (recall-comms EX-10): an office closure notice, reactivation of
 * patients with no recall and no recent visit, and an unscheduled-treatment
 * reminder, with the consent and segment rules and a preview that lists
 * every excluded number with the reason before anything is sent.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'campaigns',
    title: 'Campaigns',
    version: '0.1.0',
    owner: 'WP3-REMIND',
    entitlementKey: null,
    permissions: ['comms.view', 'settings.manage'],
    routes: [
      {
        id: 'campaigns',
        path: '/campaigns',
        title: 'Campaigns',
        permission: 'comms.view',
        officeScope: 'location-or-all',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Campaigns',
        group: 'patients',
        routeId: 'campaigns',
        icon: 'message-square',
        order: 37,
        permission: 'comms.view',
      },
    ],
    commands: [
      {
        id: 'campaigns.open',
        title: 'Go to Campaigns',
        keywords: [
          'closure notice',
          'office closed',
          'reactivation',
          'unscheduled treatment',
          'mass text',
        ],
        routeId: 'campaigns',
        permission: 'comms.view',
      },
    ],
    phiReadPoints: ['campaigns.preview'],
  }),
  pages: {
    campaigns: () => import('./CampaignsPage.js'),
  },
});
